import Swiper, { Navigation, Pagination } from "swiper";

const Testimonials = {
  init() {

    const testiEl = $(".testi");
    let swiperInstance = null; // Store the Swiper instance

    if (!testiEl.length) {
      return;
    }
    function initSwiper() {
      const navPrev = testiEl.find(".swiper-button-prev");
      const navNext = testiEl.find(".swiper-button-next");

      swiperInstance = new Swiper(testiEl.find(".testi-slider")[0], {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
          prevEl: navPrev[1],
          nextEl: navNext[1],
        },
        pagination: {
          el: testiEl.find(".swiper-pagination")[1],
          bulletElement: "button",
          clickable: true,
        },
        breakpoints: {
          1200: {
            pagination: {
              el: testiEl.find(".swiper-pagination")[0],
            },
            navigation: {
              prevEl: navPrev[0],
              nextEl: navNext[0],
            },
          },
        },
      });
    }

    function updateSwiper() {
      const viewportWidth = window.innerWidth;

      // Destroy existing Swiper instance if it exists
      if (swiperInstance !== null) {
        swiperInstance.destroy(true, true);
      }

      // Reinitialize Swiper with updated settings
      initSwiper();
    }

    // Initialize Swiper on page load
    if (testiEl.length) {
      updateSwiper();
    }

    // Listen for window resize events
    $(window).resize(function () {
      updateSwiper();
    });
  }
};

export default Testimonials;
